module.exports = __webpack_public_path__ + "img/42_26.26c4f5c2.png";